<section id="publications">
	<br/>
  <i class="fas fa-tasks speaker-icon text-center"></i>
  <h2 class="section-heading">Publications / Proceedings</h2>
  <ul class="list-group text-center">
  	<li class="list-group-item"><img src="./images/Trans_IIM_front_page.jpg" height="86"> Transactions of the Indian Institute of Metals (Springer) - SCOPUS, Web of Science and <strong>SCIE</strong> indexed journal
  		<img src="./images/springer.jpeg" height="86"></li>
  	<li class="list-group-item"><img src="./images/Int_journal_of_material_research.png" height="86">International Journal of Materials Research (Zeitschrift für Metallkunde) - SCOPUS, Web of Science and <strong>SCIE</strong> indexed journal
  		<img src="./images/De_Gruyter_logo.jpg" height="86"><br>
  	</li>
  	<li class="list-group-item"><img src="./images/MTP.jpg" height="86">Materials Today Proceedings (Elsevier) - <strong>SCOPUS</strong> Indexed Journal
  		<img src="./images/elsevier.jpg" height="86"><br>
  	</li>
  	<!-- <li class="list-group-item">Another exclusive SCOPUS journal - yet to confirm</li> -->
  </ul>
  <!-- <p>SCIE journal and SCOPUS journals are planned separately - .<br/>... Details Coming Soon...</p> -->
</section>
<style>
	section {
		padding-top: 86px;
		text-align: center;
	}
	i {
		display: block;
		margin: 0 auto;
		font-size: 2rem;
		padding-bottom: 1em;
	}
	h2 {
		text-align: center;
	}
	p {
		text-align: center;
		width: 80%;
		margin: 0 auto;
		font-size: 1.1em;
	}

	@media all and (min-width: 768px) {
	  p {
	    width: 60%;
	  }
	}
</style>
